import React from 'react'
import { useFormContext } from 'react-hook-form'
import useSessionStorage from '../../hooks/useSessionStorage'
import { initialFields } from '../../consts'

export default function Piso({ title, label, required = false }) {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext()

  const [storageData, setStorageData] = useSessionStorage(
    'app_data',
    initialFields
  )

  const handleChange = () => {
    setStorageData(getValues())
  }

  return (
    <div className="form-field">
      {title && <span>{title}</span>}
      <div className="form-group">
        <label htmlFor="MCCPERSTAG.TOMADOR.Piso">{label || 'Piso'}</label>
        <input
          id="MCCPERSTAG.TOMADOR.NumVia"
          className={`form-control${
            errors?.MCCPERSTAG?.TOMADOR?.Piso ? ' hasError' : ''
          }`}
          type="text"
          {...register('MCCPERSTAG.TOMADOR.Piso', {
            onChange: handleChange,
            required: required === true ? 'El Piso es obligatorio.' : false,
            pattern: {
              value: /^[0-9]*$/i,
              message: 'Has introducido caracteres no permitidos.',
            },
            maxLength: {
              value: 10,
              message: 'El Piso es demasiado largo.',
            },
          })}
        />
      </div>

      {errors?.MCCPERSTAG?.TOMADOR?.Piso && (
        <div className="error">
          <p>{errors.MCCPERSTAG.TOMADOR.Piso.message}</p>
        </div>
      )}
    </div>
  )
}
